/* eslint-disable no-loop-func */
import Phaser from 'phaser';
import ABCyaPhaser from '@abcya/abcya_phaser';
import gameData from '../gameData';
import AnimatedCharacter from '../AnimatedCharacter';
import LocalizationSoundAssetKeys from '../Localization-SoundAssetKeys';
import FontKeys from '../FontKeys';
import ABCyaLib from '@abcya/abcya_lib';

export default class Title extends Phaser.Scene {
  static get KEY() { return 'Title'; }

  create() {
    const { gameConfig } = ABCyaLib.Environment.instance;

    this.mid = ABCyaPhaser.Scene.getScreenMidPoint(this);

    this.bg = ABCyaPhaser.Images.addImage(0, 0, 'LandscapeMainBackground_4x3', this).setOrigin(0, 0);

    this.title1 = ABCyaPhaser.Images.addImage(-100, gameConfig.title.title1StartY, 'TitleA', this);
    this.title2 = ABCyaPhaser.Images.addImage(1800, gameConfig.title.title2StartY, 'TitleB', this, ABCyaPhaser.Images.LOCALIZATION_ATLAS);

    this.peopleContainer = this.add.container();
    this.people = [];
    this.peopledata = {};

    // Hard code for now the order
    const charstypes = gameData.SENSES_CHARACTERS;// //;["Smell", "Sight", "Taste", "Hear", "Touch"];
    const { waittimes } = gameConfig;
    let item = null;
    const initialDelay = 500;
    let totalWait = 0;

    for (let i = 0; i < charstypes.length; i++) {
      item = new AnimatedCharacter(this, charstypes[i]);
      item.destX = charstypes[i].x;
      item.x = charstypes[i].x;
      item.destY = charstypes[i].y;
      item.y = charstypes[i].y;
      item.scaleX = 1.0;
      item.scaleY = 1.0;
      item.alpha = 0;
      this.peopleContainer.add(item);
      this.people.push(item);
      const waitTime = waittimes[i];
      const thewait = waitTime + initialDelay;

      this.time.delayedCall(thewait, () => {this.bringCharIn(this.people[i]);});
      item.scaleInShadow(thewait, 0.3, 1.0);
      if (waitTime > totalWait) {
        totalWait = waitTime;
      }
    }
    totalWait += initialDelay + 600;

    for (let i = charstypes.length - 1; i >= 0; i--) {
      this.children.bringToTop(this.people[i]);
    }

    this.time.delayedCall(totalWait, () => {this.initTitle();});

    this.btnGo = this.add.container(0,0);
    const goBg = ABCyaPhaser.Images.addImage(0,0,'BtnGo', this.btnGo);
    ABCyaPhaser.Container.setContainerInteractive(this.btnGo);
    const goTxt = ABCyaPhaser.Text.addText(0,0, 48, 0xffffff, FontKeys._asapbold, ABCyaPhaser.Localization.instance.getLocalizedString('go_button'), this.btnGo).setOrigin(0.5);

    ABCyaPhaser.Buttons.convertToButton(this.btnGo, {
      onClick: () => {
        this.btnGo.setEnabled(false);
        this.onClickGo();
      }
    }).setEnabled(false);

    this.btnGo.alpha = 0;

    this.layoutRatio();
  }

  bringCharIn(e) {
    let snd;
    switch (e.charType) {
      case 'Smell':
        snd = LocalizationSoundAssetKeys._Smell;
        break;
      case 'Sight':
        snd = LocalizationSoundAssetKeys._Sight;
        break;
      case 'Taste':
        snd = LocalizationSoundAssetKeys._Taste;
        break;
      case 'Hear':
        snd = LocalizationSoundAssetKeys._Hear;
        break;
      case 'Touch':
        snd = LocalizationSoundAssetKeys._Touch;
        break;
    }

    ABCyaPhaser.Audio.playOneShot(snd, this, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);

    this.peopleContainer.bringToTop(e);

    ABCyaPhaser.Tweens.addTween(e, 400, { alpha: 1 }, Phaser.Math.Easing.Linear, () => {
      ABCyaPhaser.Tweens.addTween(e, 420, { scaleX: 0.5, scaleY: 0.5, alpha: 1.0 }, Phaser.Math.Easing.Quadratic.Out);
    });
  };

  initTitle() {
    ABCyaPhaser.Audio.playOneShot(LocalizationSoundAssetKeys._title, this, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);

    ABCyaPhaser.Tweens.addTween(this.title1, 300, { x: ABCyaLib.Environment.instance.gameConfig.title.title1EndY }, Phaser.Math.Easing.Quadratic.Out);
    ABCyaPhaser.Tweens.addTween(this.title2, 400, { x: ABCyaLib.Environment.instance.gameConfig.title.title2EndY }, Phaser.Math.Easing.Quadratic.Out);
    ABCyaPhaser.Tweens.addTween(this.btnGo, 400, { alpha: 1 }, Phaser.Math.Easing.Quadratic.Out, () => {
      this.btnGo.setEnabled(true);
    });

    this.goPulseTween = ABCyaPhaser.Tweens.addTween(this.btnGo, 1600, { scaleX: 1.2,scaleY: 1.2, yoyo: true, repeat: -1, repeatDelay: 3750, delay: 1200 }, Phaser.Math.Easing.Quadratic.Out);
  };

  onClickGo() {
    const len = this.people.length;
    for (let i = 0; i < len; i++) {
      this.people[i].destroy();
    }

    this.tweens.killAll();
    this.sound.stopAll();

    this.scene.start('Intro');
  };

  layoutRatio() {
    this.btnGo.x = this.mid.x;
    this.btnGo.y = this.mid.y * 2 - this.btnGo.getBounds().height / 2 - 20;

    this.peopleContainer.scaleX = 1;
    this.peopleContainer.scaleY = 1;
    this.peopleContainer.x = 0;
    this.peopleContainer.y = ABCyaLib.Environment.instance.gameConfig.title.peopleY;
  };
}